define([
	"dojo/_base/declare",
	"./StringRich"
], function(declare,StringRich) {

	return declare(StringRich, {
		canBeLarge: function(/*Context*/ctx, /*Heading*/h) {
			// summary: force value to display on own line in Property view
			return 2;
		},

		/**
		 * We want it to render it no matter whether if the content is empty
		 */
		_renderPlaceholder: function(h) {
			return true;
		}
	});
});